<template>
    <textarea class='form-control' :name='name'></textarea>
</template>
<style type="text/css">
    @import '../../node_modules/summernote/dist/summernote.css';
</style>
<script type="text/javascript">
import $ from 'jquery';
import '../assets/global/plugins/summernote/dist/summernote';
import ImagePopover from '../assets/c/editor/ImagePopover';
import ObjectPopover from '../assets/c/editor/ObjectPopover';
import '../assets/c/editor/summernote-zh-CN';
import { mapState, mapActions } from 'vuex';

if($.summernote && $.summernote.options && $.summernote.options.modules) {
    $.extend($.summernote.options.modules, {
        imagePopover: ImagePopover,
        objectPopover: ObjectPopover
    });
}

// console.log($.summernote);

export default {

    replace: true,
    inherit: false,
    // template: "<textarea class='form-control' :name='name'></textarea>",
    props: {
        /*model: {
            required: true,
            twoWay: true
        },*/
        language: {
            type: String,
            required: false,
            default: "zh-CN"
        },
        height: {
            type: Number,
            required: false,
            default: 500
        },
        minHeight: {
            type: Number,
            required: false,
            default: 160
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 900
        },
        name: {
            type: String,
            required: false,
            default: ""
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        toolbar: {
            type: Array,
            required: false,
            default: function() {
                return [
                    ["font", ["undo", "redo", "bold", "italic", "underline", "strikethrough", "superscript", "subscript", "clear"]],
                    ["fontsize", ["fontsize", "color"]],
                    ["para", ["style", "ul", "ol", "paragraph", "height"]],
                    ["color", ["color", "table", "link", "hr"]],
                    //["insert", ["link", "picture", "hr", 'video']],
                    ['customer-btns', ['imageButton', 'videoButton', 'audioButton', 'articleButton','codeButton']],
                ];
            }
        },
        config: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        }
    },
    beforeCompile: function() {
        this.isChanging = false;
        this.control = null;
    },
    mounted: function() {

        let self = this;

        let imageButton = function(context) {
            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="note-icon-picture"/> 图片',
                // tooltip: '插入图片',
                click() {
                    self.showSelectImgWin({
                        ok: function(img){
                            if(!img) {
                                return;
                            }

                            context.invoke('editor.insertImage', img.imgUrl, function ($image) {
                                $image.css('width', '100%');
                                $image.attr('data-filename', 'retriever');
                            });
                        }
                    });
                }
            });

            return button.render();
        }

        let videoButton = function(context) {

            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="fa fa-video-camera"></i>视频',
                // tooltip: '插入视频',
                click() {
                    //context.invoke('editor.insertText', 'hello world hhhhhh');
                    self.showSelectVideoWin({
                        ok: function(video){

                            if(!video) {
                                return;
                            }

                            let $video = $(
                              `<div class="article-item-unit article-video-wrap" data-id="${video.objectId}">`+
                                `<img src="${video.coverUrl}" />`+
                                `<div class="video-overlay">`+
                                  `<div class="play-btn" data-videourl="${video.videoUrl}">`+
                                  `<i class="fa fa-play-circle-o"></i></div>`+
                                `</div>`+
                              `</div>`);

                            context.invoke('editor.insertNode', $video[0], function ($v) {

                            });
                        }
                    });
                }
            });

            return button.render();
        }

        let audioButton = function(context) {

            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="fa fa-microphone"></i>音频',
                // tooltip: '插入音频',
                click() {
                    self.showSelectAudioWin({
                        ok: function(audio){
                          if(!audio) {
                              return;
                          }

                          let $audio = $(
                            `<div class="article-item-unit article-audio-wrap" data-id="${audio.objectId}"  data-audiourl="${audio.audioUrl}">`+
                              `<div class="icon-left"><i class="fa fa-volume-up audio-icon"></i></div>`+
                              `<p class="audio-name">${audio.title}</p>`+
                              // `<img src="${audio.coverUrl}" />`+
                            `</div>`);

                          context.invoke('editor.insertNode', $audio[0], function ($v) {

                          });
                        }
                    });
                }
            });

            return button.render();
        }

        let articleButton = function (context) {
            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="fa fa-newspaper-o"></i>图文链接',
                // tooltip: '插入图文链接',
                click() {
                    self.showSelectArticleWin({
                        ok: function(article){
                          if(!article) {
                              return;
                          }

                          let $article = $(
                            `<div class="article-item-unit" data-id="${article.objectId}">` +
                            `<a class="article-article-wrap" href="${article.articleUrl}" target="_blank">`+
                              `<img src="${article.coverUrl}"/>` +
                              `<div class="article-article-title"><i class="fa fa-link" style="margin-right: 10px"></i>${article.title}</div>` +
                            `</a>` +
                            `</div>`
                          );

                          context.invoke('editor.insertNode', $article[0], function ($v) {

                          });
                        }
                    });
                }
            });

            return button.render();
        }

         let codeButton = function (context) {
            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="note-icon-code"></i> 源码',
                click() {
                  $('#codeview').slideToggle();
                }
            });

            return button.render();
        }


        let removeUnitButton = function (context) {
            let ui = $.summernote.ui;

            let button = ui.button({
                contents: '<i class="note-icon-trash"></i>',
                tooltip: '删除',
                click() {
                    let $target = context.invoke('editor.restoreTarget');

                    context.invoke('editor.removeMedia', $target);

                  /*console.log('**************');
                  console.log($target);
                  console.log('**************');*/
                }
            });

            return button.render();
        }

        //  initialize the summernote
        if (this.minHeight > this.height) {
            this.minHeight = this.height;
        }
        if (this.maxHeight < this.height) {
            this.maxHeight = this.height;
        }
        var me = this;
        this.config.$el = this.control = $(this.$el);
        this.control.summernote({
            /*modules: {
                mImagePopover: ImagePopover
            },*/
            lang: this.language,
            height: this.height,
            // minHeight: this.minHeight,
            // maxHeight: this.maxHeight,
            toolbar: this.toolbar,
            // dialogsInBody: true,
            followingToolbar: false,
            popover: {
                mimage: [
                    ['float', ['floatLeft', 'floatRight', 'floatNone']],
                    ['remove', ['removeMedia']]
                ],
                image: null,
                munit: [
                    ['remove', ['removeUnitButton']]
                ]
            },
            placeholder: this.config.placeholder || this.placeholder,
            buttons: {
                imageButton,
                videoButton,
                audioButton,
                articleButton,
                codeButton,
                removeUnitButton
            },

            callbacks: {
                onInit: function(x, y, z) {
                    me.control.summernote("code", me.config.content);
                }
            }
        }).on("summernote.change", function() {
            // Note that we do not use the "onChange" options of the summernote
            // constructor. Instead, we use a event handler of "summernote.change"
            // event because that I don't know how to trigger the "onChange" event
            // handler after changing the code of summernote via ".summernote('code')" function.
            if (! me.isChanging) {
                me.isChanging = true;
                var code = me.control.summernote("code");
                me.config.content = (code === null || code.length === 0 ? null : code);
                me.$nextTick(function () {
                    me.isChanging = false;
                });
            }
        });
    },
    watch: {
        'config.content': function (val, oldVal) {
            if (! this.isChanging) {
                this.isChanging = true;
                var code = (val === null ? "" : val);
                this.control.summernote("code", code);
                this.isChanging = false;
            }
        }
    },
    methods: mapActions([
        'showSelectImgWin',
        'showSelectVideoWin',
        'showSelectAudioWin',
        'showSelectArticleWin',
        'increaseZIndex'
    ])
}
</script>

<style>
  .text-editor {
    position: relative;
  }

  .note-customer-btns{
      position: absolute !important;
      right: -230px;
      width: 200px;
      top: 85px;
  }

  .note-customer-btns .note-btn{
      display: block;
      float: none;
      width: 100%;
      text-align: left;

      padding:15px;
      padding-left:50px;
      font-size:14px;
      color: #222;
      cursor: pointer;

      border: 1px solid #eef1f5 !important;
      margin-top: -1px;
      margin-left: 0 !important;
  }
  .note-customer-btns .note-btn i{
      font-size:20px;
      margin-right: 12px;
      position: absolute;
      left:15px;
      top:50%;
      margin-top: -10px;
      line-height: 20px;
      color: #b4b4b4;
  }
  .note-customer-btns .note-btn:first-child {
      border-top-right-radius: 2px;
      border-top-left-radius: 2px;
  }
  .note-customer-btns .note-btn:last-child {
      border-bottom-right-radius: 2px;
      border-bottom-left-radius: 2px;
  }

  .note-editing-area img,
  .note-editing-area .note-editable img{
    max-width: 100%;
  }
</style>
